import React from "react";
import { Redirect } from "react-router-dom";
import { getUserDetails } from "./shared-data.service";
import { hasCategoryAccess, hasPermission } from "./permission.service";

const isAuthenticated = (): boolean => !!getUserDetails().email;

/**
 * HOC that wraps a component with auth + permission checks.
 *
 * - Not authenticated  -> redirect to /login
 * - Authenticated but missing category/sub-permission -> redirect to /app/forbidden
 *
 * Usage:
 *   PermissionRoute(Dashboard, 'Dashboard')
 *   PermissionRoute(AnswerConflicts, 'QA', 'Answer Conflicts')
 */
const PermissionRoute =
  (Component: any, category?: string, subCategory?: string) =>
  (props: any) => {
    if (!isAuthenticated()) {
      return <Redirect to="/login" />;
    }
    if (category) {
      const allowed = subCategory
        ? hasPermission(category, subCategory)
        : hasCategoryAccess(category);
      if (!allowed) {
        return <Redirect to="/app/forbidden" />;
      }
    }
    return <Component {...props} />;
  };

export default PermissionRoute;
